import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import "./Main.vue?vue&type=style&index=0&id=0c92a64e&lang=css"

const __exports__ = script;

export default __exports__